/**
 * LinkRenderer Component
 * Displays links associated with a question
 */

import React from 'react';
import { Box, Card, CardContent, Link, Typography, Icon } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import type { Question } from '../../../types';

interface LinkRendererProps {
  question: Question;
}

function LinkRenderer({ question }: LinkRendererProps): JSX.Element {
  const links = question.links || [];

  if (links.length === 0) {
    return <Box />;
  }

  return (
    <Card sx={{ mt: 3, bgcolor: '#f9f9f9' }}>
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          Related Resources
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {links.map((link) => (
            <Link
              key={link.id}
              href={link.url}
              target={link.openInNewTab ? '_blank' : '_self'}
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                color: '#00A9B5',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              <Typography variant="body2">{link.title}</Typography>
              {link.openInNewTab && <OpenInNewIcon sx={{ fontSize: '1rem' }} />}
            </Link>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default LinkRenderer;
